/**
 * Notifications système du navigateur (barre + son), comme WhatsApp Web.
 */
const ICON = '/icon-192x192.png';

export async function ensureOsNotificationPermission() {
  if (typeof window === 'undefined' || !('Notification' in window)) return 'unsupported';
  if (Notification.permission === 'granted') return 'granted';
  if (Notification.permission === 'denied') return 'denied';
  try {
    return await Notification.requestPermission();
  } catch {
    return Notification.permission;
  }
}

export function showOsNotification({ title, body, url, tag } = {}) {
  if (typeof window === 'undefined' || !('Notification' in window)) return;
  if (Notification.permission !== 'granted') return;

  try {
    const n = new Notification(title || 'Secura', {
      body: body || '',
      icon: ICON,
      badge: ICON,
      tag: tag || `secura-${Date.now()}`,
      renotify: true,
      silent: false,
    });
    n.onclick = () => {
      try {
        window.focus();
        if (url) window.location.href = url;
      } catch {
        /* ignore */
      }
      n.close();
    };
  } catch (err) {
    console.warn('Notification OS:', err?.message || err);
  }
}
